import { BaseFlowRuleStep } from "./BaseFlowRuleStep";
import { TreeRuleConfiguration } from "../../../Rule/Tree/TreeRuleConfiguration";

export class RunTreeRule extends BaseFlowRuleStep {
    readonly __type: string = "run_tree_rule";

    executable: TreeRuleConfiguration = new TreeRuleConfiguration();

    constructor() {
        super();
        this.name = "Run Tree Rule";
    }
}
